import {createContext} from 'react';
import type {InformersAPI} from '@/informers/services/InformersAPI';

export const ServicesContext = createContext<{
	informersAPI: InformersAPI;
} | null>(null);

ServicesContext.displayName = 'ServicesContext';
